import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconCheckIndeterminateSmallLine = ({
  width,
  height,
  fill = 'currentColor',
  ...props
}: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 13a.967.967 0 0 1-.713-.287A.968.968 0 0 1 6 12c0-.283.096-.52.287-.713A.967.967 0 0 1 7 11h10a.97.97 0 0 1 .712.287c.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 17 13H7Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconCheckIndeterminateSmallLine;
